import { render, staticRenderFns } from "./ShowMedia.vue?vue&type=template&id=05841bb4&scoped=true&"
import script from "./ShowMedia.vue?vue&type=script&lang=js&"
export * from "./ShowMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05841bb4",
  null
  
)

export default component.exports